import React from "react";
import PropTypes from "prop-types";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import {
  SALES_PERSON,
  PRODUCT,
  CONTRACT_NUMBER,
  DEBITOR,
  BILLING_GROUP,
  PARAM_PRODUCT,
} from "../../../utils/responseValue";

import { MIN_DESKTOP_WIDTH } from "../../../constants/ui";
import {
  useDefaultPasscodeStyles,
  textfield,
  selectField,
  getSelectValues,
  getSelectedValueTranslated,
  getKeyFromSelectedValue,
} from "../../../constants/passCodeUtils";

// TODO: cost Center

const PMBillingData = ({ confRestRep, setConfRestRep, selectValues, translate }) => {
  const pc = useDefaultPasscodeStyles();
  const isDesktop = useMediaQuery(`(min-width:${MIN_DESKTOP_WIDTH})`);

  const handleTextChange = name => event => {
    setConfRestRep({ ...confRestRep, [name]: event.target.value });
  };

  const handleSelectChange = (name, confKey) => event => {
    setConfRestRep({
      ...confRestRep,
      [confKey || name]: getKeyFromSelectedValue(selectValues[name], event.target.value),
    });
  };

  const customStyle = () => ({
    formControl: {
      width: "200px",
    },
  });

  return (
    <Box component="form" sx={pc.container} noValidate autoComplete="off">
      <Box sx={pc.centerer}>
        {selectField(
          customStyle,
          translate[PARAM_PRODUCT],
          getSelectValues(selectValues, PARAM_PRODUCT),
          getSelectedValueTranslated(confRestRep[PRODUCT], selectValues, PARAM_PRODUCT),
          handleSelectChange(PARAM_PRODUCT, PRODUCT),
        isDesktop
        )}
        {selectField(
          customStyle,
          translate[SALES_PERSON],
          getSelectValues(selectValues, SALES_PERSON),
          getSelectedValueTranslated(confRestRep[SALES_PERSON], selectValues, SALES_PERSON),
          handleSelectChange(SALES_PERSON),
        isDesktop
        )}
      </Box>
      <Box sx={pc.lineBreak} />
      {textfield(
        pc,
        isDesktop,
        confRestRep[CONTRACT_NUMBER],
        translate[CONTRACT_NUMBER],
        handleTextChange(CONTRACT_NUMBER)
      )}
      {textfield(pc, isDesktop, confRestRep[DEBITOR], translate[DEBITOR], handleTextChange(DEBITOR))}
      <Box sx={pc.lineBreak} />
      {textfield(
        pc,
        isDesktop,
        confRestRep[BILLING_GROUP],
        translate[BILLING_GROUP],
        handleTextChange(BILLING_GROUP)
      )}
      {textfield(pc, isDesktop, confRestRep.costCenter, translate.costCenter, handleTextChange("costCenter"))}
      <Box sx={pc.lineBreak} />
    </Box>
  );
};

PMBillingData.propTypes = {
  confRestRep: PropTypes.object.isRequired,
  selectValues: PropTypes.object.isRequired,
  setConfRestRep: PropTypes.func.isRequired,
  translate: PropTypes.object.isRequired,
};

export default PMBillingData;
